import { AccidentsIncidentsScreen } from "app/screens/residents/show/AccidentsIncidentsScreen";

export default function AccidentsIncidentsPage() {
  return <AccidentsIncidentsScreen />;
}
